import sessionTokenSlice from './sessionToken'

export const sessionTokenServiceReducers = sessionTokenSlice.reducer

export const sessionTokenServiceActions = {
  ...sessionTokenSlice.actions,
}